import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgGlobeFill} from "~/assets/svg/globe-fill.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmGlobeFillIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgGlobeFill id={id} className={cx(simpleIconStyles(size), commonStyles.strokeColor(color), className)} />;
};
